/**
 * auth.jsx — client-side auth state
 *
 * Loads the stored JWT, fetches the current user from /api/me, and exposes it
 * through <AuthProvider> / useAuth(). Also owns login redirects and logout.
 */

import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, token } from './api.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!token.get()) { setUser(null); return null; }
    try {
      const { user } = await api.me();
      setUser(user);
      return user;
    } catch {
      token.clear();
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => { await refresh(); setLoading(false); })();
  }, [refresh]);

  const login  = (provider) => { window.location.href = api.auth.loginUrl(provider); };
  const logout = () => { token.clear(); setUser(null); window.location.href = '/login'; };

  return (
    <AuthContext.Provider value={{ user, loading, refresh, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
